/* eslint no-use-before-define: "off" */

import * as fonts from 'common/fonts';
import { PropertyBranding } from 'common/types';

export { setBranding };

// Backwards compatibility
const backwardsCompatibleEntries = (obj: any) => {
  const ownProps = Object.keys(obj);
  let i = ownProps.length;
  const resArray = new Array(i); // preallocate the Array

  while ((i -= 1)) resArray[i] = [ownProps[i], obj[ownProps[i]]];
  return resArray;
};

const setBranding = (branding: PropertyBranding) => {
  const root = document.documentElement;
  // Map CSS variable names to the corresponding keys in the JSON data file
  const map = {
    '--accent-colour': 'accentColour',
    '--primary-font': 'titleFont',
    '--secondary-font': 'bodyFont',
    '--logo-image': 'logoImageURL',
    '--logo-image-address': 'logoImageAddress',
    '--header-image': 'headerImageURL',
    '--header-image-address': 'headerImageAddress',
    '--header-link-address': 'headerLinkAddress',
    '--subscribe-header-image-address': 'hostedSubsPageHeaderImageAddress',
    '--subscribe-logo-image-address': 'hostedSubsPageLogoImageAddress',
    '--confirmation-header-image-address':
      'hostedSubsConfirmationHeaderImageAddress',
    '--confirmation-logo-image-address':
      'hostedSubsConfirmationLogoImageAddress',
    '--verification-header-image-address':
      'hostedSubsVerificationHeaderImageAddress',
    '--verification-logo-image-address':
      'hostedSubsVerificationLogoImageAddress',
    '--unsubscribe-header-image-address':
      'hostedSubsUnsubscribeHeaderImageAddress',
    '--unsubscribe-logo-image-address': 'hostedSubsUnsubscribeLogoImageAddress',
  };
  // Backwards compatibility
  if (!Object.entries) {
    Object.entries = backwardsCompatibleEntries;
  }
  // Process each entry in the map
  for (const [cssVariable, objectKey] of Object.entries(map)) {
    // Retrieve the relevant value from the branding data file
    let cssValue = branding[objectKey as keyof PropertyBranding];
    if (cssValue) {
      // Perform any necessary formatting depending on the parameter type
      switch (cssVariable) {
        // Add hash symbol to colour hex codes
        case '--accent-colour':
          cssValue = `#${cssValue}`;
          break;
        // Load any required fonts and add a backup font name
        case '--primary-font':
        case '--secondary-font':
          fonts.loadGoogleFont(cssValue.toString());
          cssValue = `${cssValue}, serif`;
          break;
        // Add url(...) to image paths
        case '--logo-image':
        case '--header-image':
        case '--logo-image-address':
        case '--header-image-address':
        case '--subscribe-header-image-address':
        case '--subscribe-logo-image-address':
        case '--confirmation-header-image-address':
        case '--confirmation-logo-image-address':
        case '--verification-header-image-address':
        case '--verification-logo-image-address':
        case '--unsubscribe-header-image-address':
        case '--unsubscribe-logo-image-address':
          cssValue = `url('${cssValue}')`;
          break;
        default:
      }
      // Update the CSS variable with the new value
      root.style.setProperty(cssVariable, cssValue.toString(), 'important');
    }
  }
};
